var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useRef, useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import styled from 'styled-components';
import { ContextualHelpNotification } from '../ContextualHelpNotification';
import { FormFieldHelper } from '../FormFieldHelper';
import { Space } from '../Space';
import { extractFormFieldHelperProps } from './utils';
var InlineContextualHelp = styled(ContextualHelpNotification)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var space = _a.theme.space;
    return "\n    display: inline-flex;\n    width: fit-content;\n    height: 44px;\n    align-items: center;\n    margin-left: ".concat(space.xs, ";\n    padding-top: 3px;\n  ");
});
export var useFormText = function (_a) {
    var _b;
    var props = _a.props;
    var variant = props.variant, labelContent = props.labelContent, errorNotification = props.errorNotification, className = props.className;
    var staticId = useRef(uuid()).current;
    var characterCounterRef = useRef(null);
    var _c = __read(useState(), 2), stackedDescribedBy = _c[0], setStackedDescribedBy = _c[1];
    var formFieldHelperProps = useMemo(function () {
        var extractedProps = extractFormFieldHelperProps(props);
        return __assign(__assign({}, extractedProps), { characterCounter: __assign(__assign({}, extractedProps.characterCounter), { ref: characterCounterRef }) });
    }, [props]);
    var formFieldHelper = useMemo(function () { return (React.createElement(Space, { mt: "xs" },
        React.createElement(FormFieldHelper, __assign({ onDescribedByChange: setStackedDescribedBy }, formFieldHelperProps)))); }, [formFieldHelperProps, setStackedDescribedBy]);
    var inlineContextualHelp = useMemo(function () {
        if (!props.contextualHelp ||
            props.contextualHelp.variant !== 'inline' ||
            !props.contextualHelp.content)
            return null;
        var _a = props.contextualHelp, content = _a.content, customId = _a.customId;
        var helpId = customId || "help-id-".concat(staticId);
        return {
            id: helpId,
            element: React.createElement(InlineContextualHelp, { id: helpId, content: content }),
        };
    }, [props.contextualHelp, staticId]);
    return {
        variant: variant,
        labelContent: labelContent,
        className: className,
        describedBy: stackedDescribedBy,
        formTextId: props.id || "mui-text-field-".concat(staticId),
        hasError: !!(errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.message) || !!(errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.customId),
        isDisabled: !!props.disabled,
        formFieldHelper: formFieldHelper,
        inlineContextualHelp: (inlineContextualHelp === null || inlineContextualHelp === void 0 ? void 0 : inlineContextualHelp.element) || null,
        characterCounterWidth: 
        // the + 15 accounts for 8px padding to the right of the character counter
        // and gives an extra 2px padding to the left of it
        Math.ceil(((_b = characterCounterRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) || 0) + 15,
    };
};
var templateObject_1;
//# sourceMappingURL=useFormText.js.map